/* eslint-disable no-dupe-keys */
export default {
  material_templates: {
    name: '资料模版',
    // 属性（一般与对象内容匹配）
    prop: {
      name: '资料模版名',
      content: '内容',
      status: '模版状态',
      attachments: '附件',
      created_at: '创建时间',
      updated_at: '更新时间'
    },
    // Enum的属性
    statuses: {
      enabled: '可用',
      disabled: '不可用'
    },
    // 占位提示
    placeholder: {
      search_keyword: '查询资料模版名/内容'
    },
    // 详情页标签
    detail_tags: {
      detail: '基本信息',
      material_referred_record: '上传的资料'
    },
    // 标签标题
    // 标题
    group_titles: {
      base: '基本信息',
      attachment: '附件'
    }
  }
}
